
import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import api from '../../../api/Api';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function AssetDetails() {
  const { identy } = useParams();


  const [a, setAsset] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate()

  useEffect(() => {
    api.get(`/api/assets/${identy}`)
      .then((response) => { setAsset(response.data.response) })
      .catch(() => setError("Failed to fetch Asset."));
  }, [identy]);

  if (error) return <p className='text-center text-danger'>{error}</p>;
  if (!a) return <p className='text-center mt-5'>Loading Asset...</p>;

  const handleEdit = () => {
    navigate(`/assets/edit/${identy}`);

  }
  const handleViewLogs = () => {
  navigate(`/assets/logs/${a.identy}`);
};


  const handleDelete = () => {
    const confirmDelete = window.confirm("Are you sure you want to delete this asset ?");
    if (!confirmDelete) return;

    api.delete(`/api/assets/${identy}`)
      .then(() => {
        navigate("/assets");
      })
      .catch((err) => {
      const msg = err.response?.data?.message || "Failed to delete Asset.";
      toast.error(msg);
    });
  };

return (
  <div className="container">
    {/* <ToastContainer position="bottom-right" autoClose={3000} /> */}
    <div className="d-flex justify-content-between align-items-center mb-3">
      <Link to={`/assets/type/${a.assetType?.identy}`} className="btn btn-secondary m-3">← Back </Link>
      <div><h4 className="fw-bold text-capitalize">{a.assetName}</h4></div>
      <div className="d-flex gap-2">
        <button className="btn  btn-secondary m-1"onClick={handleViewLogs}>Logs</button>
        <button className="btn btn-secondary m-1" onClick={handleEdit}>Edit</button>
        <button className="btn btn-danger m-1" onClick={handleDelete}>Delete</button>
      </div>
    </div>


    <div className="row bg-white p-4">

      <div className="col-md-6 container">
        {Object.entries(a)
          .filter(([key]) => key !== 'identy' && key !== 'assignedEmployees' && key !== 'assetType' && key !== 'attributes')
          .map(([key, value]) => {

            let displayValue = value;
            if(key === 'purchaseCost' && typeof value === 'number'){
              displayValue = value.toLocaleString('en-IN',{
                style : 'currency', 
                currency: 'INR',
                minimumFractionDigits: 0, 
                maximumFractionDigits: 0
              });
            }
            else if(value === null || value === undefined || value ===""){
              displayValue = "N/A";
            }
          
          return(
            <div key={key} className="mb-2">
              <strong className="text-capitalize">{key.replace(/([A-Z])/g, ' $1')}:</strong>{" "} 
              {displayValue}
            </div>
          );
        })}
      </div>

  
      <div className="col-md-6 container">
        {a.assetType && (
          <div className="mb-2">
            <h5 className="fw-bold">Asset Type</h5>
            <p>{a.assetType.assetTypeName}</p>
          </div>
        )}


        {Array.isArray(a.assignedEmployees) && a.assignedEmployees.length > 0 && (
          <div className="mb-2">
            <h5 className="fw-bold">Assigned Employees</h5>

            <ul className="ms-3">
              {a.assignedEmployees.map(emp => (
                <li key={emp.identy}>
                  {emp.employeeName} ({emp.employeeId}) – <strong>{emp.shift + " Shift"}</strong>
                </li>
              ))}
            </ul>
          </div>
        )}


        

        {a.attributes && a.attributes.length > 0 && (
          <div>
            <h5 className="fw-bold">Specification</h5>
            <ul className="ms-3">
              {a.attributes.map(attr => (
                <li key={attr.identy}>
                  <strong>{attr.attributeKey}:</strong> {attr.attributeValue}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  </div>
);

}

export default AssetDetails;
